import styled from 'styled-components'

import mobileBg from './header-bg-mobile.png'
import reviewBg from './review.png'

const mobile = 'max-width: 1000px'

export const Root = styled.div`
  background: #f5efed;
  padding: 46px 0 70px;

  & h2 {
    padding: 0;
    margin-bottom: 24px;
  }

  @media only screen and (${mobile}) {
    background-color: #fff;
    background-image: url(${mobileBg});
    background-size: cover;
    background-position: center;
  }
`

export const Banner = styled.div`
  padding: 24px;
  box-sizing: border-box;
  background-color: #fff;
  background-image: url(${reviewBg});
  width: 553px;
  min-height: 714px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  background-position: center;
  background-size: cover;
  flex-shrink: 0;
  margin-left: 80px;
  @media only screen and (${mobile}) {
    display: none;
  }
`

export const Image = styled.img`
  margin-left: 15px;
  margin-bottom: -20px;
`

export const Review = styled.div`
  padding: 16px 20px;
  background: #fff;
  border-radius: 10px;

  font-family: Helvetica Neue;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.01em;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
  @media only screen and (${mobile}) {
    box-shadow: 0px 1px 12px 0px #00000014;
  }
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & span:nth-child(2) {
    flex-shrink: 0;
  }
`

export const Title = styled.span`
  font-family: Helvetica Neue;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.01em;
  text-align: left;
  margin-bottom: 16px;

  & img {
    margin-top: 6px;
    display: block;
  }
`

export const MobileBanner = styled.img`
  max-width: 315px;
  width: 100%;
  margin: 0 auto 22px;
  display: none;
  box-shadow: 0px 4px 40px 0px #9300001a;
  border-radius: 10px;
  @media only screen and (${mobile}) {
    display: block;
  }
`
